import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useHistory, withRouter } from "react-router-dom"
import { isEmpty } from "lodash"
import { Button, Col, Container, Row } from "reactstrap"

//Import Common Components
import Breadcrumbs from "components/Common/Breadcrumb"
import DeleteModal from "components/Common/DeleteModal"

import { deleteCompany, getCompanyDetail } from "store/companies/actions"
import CompanyDetail from "./companyDetail"
import TeamMembers from "./teamMembers"
// import OverviewChart from "./overviewChart"
// import AttachedFiles from "./attachedFiles"
// import Comments from "./comments"

//redux
import { useSelector, useDispatch } from "react-redux"

const CompanyOverview = props => {
  //meta title
  document.title = "Company Overview | React Admin & Dashboard Template"
  const history = useHistory()
  const [deleteModal, setDeleteModal] = useState(false)
  const dispatch = useDispatch()

  const { loading, error, companyDetail } = useSelector(state => ({
    loading: state.apiGlobal.loading,
    error: state.apiGlobal.error,
    companyDetail: state.Companies.companyDetail,
  }))

  const {
    match: { params },
  } = props

  useEffect(() => {
    if (params && params.id) {
      dispatch(getCompanyDetail(params.id))
    }
  }, [params, getCompanyDetail])

  useEffect(() => {
    if (!loading && !companyDetail.id && error.message) {
      history.goBack()
    }
  }, [loading, companyDetail])

  const handleDeleteEvent = async () => {
    dispatch(deleteCompany(params.id))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteEvent}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Companies" breadcrumbItem="Company Overview" />

          {!isEmpty(companyDetail) && (
            <>
              <Row>
                <Col lg="8">
                  <CompanyDetail company={companyDetail} />
                </Col>

                <Col lg="4">
                  <Button
                    color="danger"
                    className="float-end"
                    onClick={() => setDeleteModal(true)}
                  >
                    Delete
                  </Button>
                  {/* <TeamMembers team={companyDetail.owner} /> */}
                </Col>
              </Row>

              {/* <Row>
                <Col lg="4">
                  <OverviewChart options={options} series={series} />
                </Col>

                <Col lg="4">
                  <AttachedFiles files={companyDetail.files} />
                </Col>

                <Col lg="4">
                  <Comments comments={companyDetail.comments} />
                </Col>
              </Row> */}
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

CompanyOverview.propTypes = {
  match: PropTypes.object,
}

export default withRouter(CompanyOverview)
